import { Client } from "@/Common/Api/Client";
import { LicencedIntervenor } from "@/Common/Api/MedfarDictionaries/Dto/Responses/LicencedIntervenor";
import { SearchLicenceResult } from "@/Common/Api/MedfarDictionaries/Dto/Responses/SearchDoctorResults";
import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { Person } from "@/Common/Models/Person/Person";
import { PersonDropdownItem } from "@/Common/Models/UI/Inputs/PersonDropdownItem";
import * as ServerOperations from "@/Common/Operations/operations.server";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";

import styles from "./ReferalDoctorSearchAutocompleteCustom.module.scss";

interface IReferalDoctorSearchAutocompleteCustomProps {
    componentId: string;
    selectedDoctors: Immutable.List<Person>;
    selectionOp?: number;
    selectionCallBack?: (p: PersonDropdownItem, i: LicencedIntervenor) => void;
    LicenceOrganisationRuleId?: string;

    clearOp?: number;
    clearCallBack?: any;

    disabled?: boolean;
    focusOnLoad?: boolean;
    useblurevent?: boolean;
    closeDropDownAfterSelection?: boolean;

    changedTextValueEvent?: number;
    changedTextValueCallback?: any;

    placeholder?: string;
    defaultTextValue?: string;
    resetValueOnDefaultValueChange?: boolean;

    updateStateCallBack?: (textValue: string) => void;

    setFirstItem?: boolean;

    displayList?: boolean;

    style?: React.CSSProperties;
}

class ReferalDoctorSearchAutocompleteCustomState {
    public textValue: string;
    public expanded: boolean;
    public infocus: boolean;
    public doctors: LicencedIntervenor[];

    constructor(s?: ReferalDoctorSearchAutocompleteCustomState) {
        if (s != null) {
            this.textValue = s.textValue;
            this.expanded = s.expanded;
            this.infocus = s.infocus;
            this.doctors = s.doctors;
        }
        else {
            this.expanded = false;
            this.textValue = ""; this.doctors = [];
        }
    }
}

class ReferalDoctorSearchAutocompleteCustom extends BaseReactComponent<IReferalDoctorSearchAutocompleteCustomProps, ReferalDoctorSearchAutocompleteCustomState> {
    private debounceMs: number = 150;
    private minQueryLengthSearchChars: number = 2;
    private returnMaxResults: number = 15;
    private blurBuffer: number;
    private timeoutReference: any;
    private flagForDefaultValueReset: boolean = false;

    constructor(props: IReferalDoctorSearchAutocompleteCustomProps) {
        super(props);
        const infocus = props.focusOnLoad === true;
        const textValue = props.defaultTextValue?.length > 0 ? props.defaultTextValue : "";

        this.state = new ReferalDoctorSearchAutocompleteCustomState({
            textValue,
            expanded: false,
            infocus,
            doctors: []
        });
    }

    public componentDidMount(): void {
        if (this.props.useblurevent == null || this.props.useblurevent === false) {
            $(window).on("click.pc", this.onWindowClick.bind(this));
        }

        if (this.props.focusOnLoad) {
            $("#" + this.props.componentId).find('input[type="text"]').focus();
        }

        if (this.props.setFirstItem === false) {
            if (this.props.defaultTextValue != "" && this.props.defaultTextValue != null) {
                const matches = this.props.defaultTextValue.match(/\((.*?)\)/);

                if (matches) {
                    this.mutateState(s => {
                        s.textValue = matches[1];
                    });
                }
            }
        }
    }

    public render(): JSX.Element {
        var self = this;

        var referringDoctors: JSX.Element[] = [];
        if (self.props.selectedDoctors) {
            self.props.selectedDoctors.forEach((p: Person, idx: number) => {
                referringDoctors.push(
                    <li onClick={self.stopPropagation.bind(self)} className={styles.autocomplete_li} key={`${p.ContactId}_${idx}`}>
                        <span className="content-text">{p.Name} {p.Licence ? `(${p.Licence}) ` : ""}</span>
                        <span className={`pointer ${styles.autocomplete_item_remove}`} onClick={self.removeItem.bind(self, p)}>X</span>
                    </li>
                );
            });
        }

        var dropdownPart = (
            <div id={"Parentdiv_" + this.props.componentId} className="doctor-autocomplete">
                <div className="doctor-results-ps">
                    <div className={`doctor-results-container  ${styles.autocomplete_doctorsResultContainerStyles}`}>
                        <div className={styles.autocomplete_doctorsResultList}>
                            <ul className="doctor-result-list">
                                {this.state.doctors.map((i: LicencedIntervenor, idx: number) => {
                                    var css = i.IsHighlighted == true ? "pending" : "";

                                    return (
                                        <li className={css} key={i.Id + "_" + idx} onClick={self.onItemClick.bind(self, i)}>
                                            <div className="doctor-result">
                                                <h5>{`${i.FirstName}, ${i.LastName} (${LicencedIntervenor.GetLicence(i)})${i.OrganisationCode ? ` ${i.OrganisationCode}` : "" }`}</h5>
                                                {!IsNullOrWhiteSpace(i.Address) && (
                                                    <p>
                                                        <span>{i.Address}</span>
                                                    </p>
                                                )}
                                                <p>
                                                    <span>{i.Phone}</span>
                                                    {!IsNullOrWhiteSpace(i.Fax) &&
                                                        <span className={styles.autocomplete_doctorsResultContainer_Phone}>{`Fax: ${i.Fax}`}</span>
                                                    }
                                                </p>
                                            </div>

                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        );

        if (!this.state.expanded || this.state.doctors.length === 0) { dropdownPart = null; }

        var bottomPad = null;
        if (this.state.infocus === false && this.props.selectedDoctors && this.props.selectedDoctors.size > 0) {
            bottomPad = <div className={styles.autocomplete_bottompad} />;
        }

        var input = null;

        if (this.state.infocus === true || (!this.props.selectedDoctors || this.props.selectedDoctors.size === 0)) {
            input = <input placeholder={this.props.placeholder} onKeyDown={this.inputKeyDown.bind(this)} onBlur={this.onBlur.bind(this)} onChange={this.searchTextChanged.bind(this)} disabled={this.props.disabled} value={this.state.textValue} type="text" className="form-control" style={this.props.style} />;
        }

        return (
            <div id={this.props.componentId} onClick={this.onContainerClick.bind(this)}>
                <div className="ui-wrp-a clearfix">
                    {this.props.displayList && (
                        <ul className="selected-items-list clearfix">
                            {referringDoctors}
                        </ul>
                    )}

                    {input}
                    {bottomPad}
                </div>

                {this.state.doctors.length > 0 &&
                    dropdownPart
                }
            </div>
        );
    }

    private onBlur(): void {
        if (this.props.useblurevent === true) {
            this.onControlLeave();
        }

        if (this.props.updateStateCallBack) {
            this.props.updateStateCallBack(this.state.textValue);
        }
    }

    public shouldComponentUpdate(nextProps: IReferalDoctorSearchAutocompleteCustomProps, nextState: ReferalDoctorSearchAutocompleteCustomState): boolean {
        let self = this;
        let qs = this.state.textValue !== nextState.textValue;
        let selectionChanged = this.props.selectedDoctors !== nextProps.selectedDoctors;
        let patientsChanged = this.state.doctors !== nextState.doctors;
        let id = this.props.componentId !== nextProps.componentId;
        let dropdown = this.state.expanded !== nextState.expanded;
        let defaultTextChanged = this.props.defaultTextValue !== nextProps.defaultTextValue;
        let disabledChange = this.props.disabled !== nextProps.disabled;

        if (id || defaultTextChanged)
            self.flagForDefaultValueReset = true;

        return patientsChanged || selectionChanged || qs || dropdown || defaultTextChanged || id || disabledChange;
    }

    public componentWillUpdate(): void {
        var self = this;

        if (self.flagForDefaultValueReset && self.props.resetValueOnDefaultValueChange) {
            self.flagForDefaultValueReset = false;
            var s = new ReferalDoctorSearchAutocompleteCustomState(self.state);
            s.textValue = self.props.defaultTextValue ? self.props.defaultTextValue : "";
            self.setState(s);
        }
    }

    public componentWillUnmount(): void {
        if (this.props.useblurevent == null || this.props.useblurevent === false) {
            $(window).off("click.pc");
        }
        super.componentWillUnmount();
    }

    private stopPropagation(e: React.MouseEvent): void {
        e.stopPropagation();
    }

    private onContainerClick(e: React.MouseEvent): void {
        e.stopPropagation();
        var self = this;
        var s = new ReferalDoctorSearchAutocompleteCustomState(this.state);
        s.expanded = true;
        s.infocus = true;
        this.setState(s);

        window.setTimeout(() => {
            var tb = $("#" + self.props.componentId).find('input[type="text"]');
            var val = tb.val();
            tb.val(""); tb.focus(); tb.val(val);
        }, 50);
    }

    private onWindowClick(): void {
        var s = new ReferalDoctorSearchAutocompleteCustomState(this.state);
        s.expanded = false;
        if (this.props.selectedDoctors.size > 0) { s.infocus = false; }
        this.setState(s); // render with dropdown
    }

    private onControlLeave(): void {
        var self = this;
        this.blurBuffer = window.setTimeout(() => {
            var s = new ReferalDoctorSearchAutocompleteCustomState();

            s.expanded = false;

            if (self.props.selectedDoctors && self.props.selectedDoctors.size > 0)
                s.infocus = false;

            s.doctors = self.state.doctors;
            s.textValue = self.state.textValue;
            self.setState(s); // render with dropdown
        }, 300);
    }

    private inputKeyDown(e: React.KeyboardEvent): void {
        if (e.keyCode === 8) {
            // delete last item
            if (e.ctrlKey) {
                if (this.state.textValue.length === 0) {
                    if (!(this.props.clearOp == null)) {
                        var operation = new LocalEvent(this.props.clearOp);
                        LocalEventDispatcher.dispatch(operation);
                    }
                    else if (!(this.props.clearCallBack == null)) {
                        this.props.clearCallBack();
                    }
                }
            }
            else {
                if (this.props.selectedDoctors && this.props.selectedDoctors.size > 0 && this.state.textValue.length === 0) {
                    var size = this.props.selectedDoctors.size;

                    var model = new PersonDropdownItem();
                    model.Item = this.props.selectedDoctors.get(size - 1);

                    if (!(this.props.selectionOp == null)) {
                        var operation = new LocalEvent(this.props.selectionOp);
                        model.Active = false;
                        operation.AddItem("value", model);
                        LocalEventDispatcher.dispatch(operation);
                    }
                    else if (!(this.props.selectionCallBack == null)) {
                        this.props.selectionCallBack(model, null);
                    }
                }
            }
        }

        // up
        if (e.keyCode === 38) { e.preventDefault(); this.previousItem(); }

        // down
        if (e.keyCode === 40) { e.preventDefault(); this.nextItem(); }

        // enter
        if (e.keyCode === 13) { this.addSelectedItem(); }

        // escape
        if (e.keyCode === 27) {
            this.clearState();
        }
    }

    // keyboard triggered
    private nextItem(): void {
        var collection = this.state.doctors;
        var idx = this.indexOfSelectedItem();
        if (idx === -1) {
            collection[0].IsHighlighted = true;
            this.updateStateWithNewReferalDoctorList(collection, true);
            return;
        }
        if (idx + 1 < collection.length) {
            collection[idx].IsHighlighted = false;
            collection[idx + 1].IsHighlighted = true;
            this.updateStateWithNewReferalDoctorList(collection, true);
        }
        this.scrollDown();
    }

    private scrollUp(): void {
        var container = $("#" + this.props.componentId);
        var scrollContainer = container.find("div.ui-wrp-b");
        if (scrollContainer != null && scrollContainer.css("max-height") != null) {
            var maxHeight = +scrollContainer.css("max-height").replace("px", "");
            var ul = container.find('ul[data-role="available-options"]');
            var sct = scrollContainer.scrollTop();
            var hightlightedItemPosition = (ul.find("li.pending").offset().top - ul.offset().top);
            var pr = Math.round((hightlightedItemPosition / maxHeight) * 100);
            if (pr < 100) { scrollContainer.scrollTop(sct - 50); }
        }
    }

    private scrollDown(): void {
        var container = $("#" + this.props.componentId);
        var scrollContainer = container.find("div.ui-wrp-b");
        if (scrollContainer != null && scrollContainer.css("max-height") != null) {
            var maxHeight = +scrollContainer.css("max-height").replace("px", "");

            var ul = container.find('ul[data-role="available-options"]');
            var sct = scrollContainer.scrollTop();
            var hightlightedItemPosition = (ul.find("li.pending").offset().top - ul.offset().top);

            var pr = Math.round((hightlightedItemPosition / maxHeight) * 100);
            if (pr > 50) { scrollContainer.scrollTop(sct + 50); }
        }
    }

    // keyboard triggered
    private previousItem(): void {
        var idx = this.indexOfSelectedItem();
        if (idx === -1) {
            this.collapseDropdown();
            return;
        }

        var collection = this.state.doctors;
        if (idx === 0) {
            collection[0].IsHighlighted = false;
            this.updateStateWithNewReferalDoctorList(collection, false);
            return;
        }

        if (idx > 0) {
            collection[idx].IsHighlighted = false;
            idx--;
            collection[idx].IsHighlighted = true;
            this.updateStateWithNewReferalDoctorList(collection, true);
        }

        else if (idx === 1) {
            collection[0].IsHighlighted = true;
            collection[1].IsHighlighted = false;
            this.updateStateWithNewReferalDoctorList(collection, false);
        }

        this.scrollUp();
    }

    // keyboard triggered
    private addSelectedItem(): void {
        var idx = this.indexOfSelectedItem();
        if (idx >= 0) {
            var person = new PersonDropdownItem();
            var intervenor = this.state.doctors[idx];
            person.Item = Person.FromMedfarDictionnaryLicence(this.state.doctors[idx]);

            if (!(this.props.selectionOp == null)) {
                var operation = new LocalEvent(this.props.selectionOp);
                operation.AddItem("value", person);
                LocalEventDispatcher.dispatch(operation);
            }
            else if (!(this.props.selectionCallBack == null)) {
                this.props.selectionCallBack(person, intervenor);
            }

            this.clearQuestyString();

            if (this.props.closeDropDownAfterSelection) { this.clearState(); }
        }
    }

    private updateStateWithNewReferalDoctorList(list: LicencedIntervenor[], expand: boolean): void {
        var state = new ReferalDoctorSearchAutocompleteCustomState(this.state); state.expanded = expand;
        state.doctors = list.map(i => i); this.setState(state);
    }

    // returns index of item in state.patients array of active item
    private indexOfSelectedItem(): number { if (this.state.doctors.length === 0) return -1; for (var i = 0; i < this.state.doctors.length; i++) { if (this.state.doctors[i].IsHighlighted) { return i; } } return -1; }

    private onItemClick(item: LicencedIntervenor, e: React.MouseEvent): void {
        e.stopPropagation();
        if (this.blurBuffer != null) {
            clearTimeout(this.blurBuffer);
            this.blurBuffer = null;
        }

        item.IsHighlighted = true;

        var person = new PersonDropdownItem();
        person.Item = Person.FromMedfarDictionnaryLicence(item);

        if (!(this.props.selectionOp == null)) {
            var operation = new LocalEvent(this.props.selectionOp);
            operation.AddItem("value", person);
            operation.AddItem("intervenor", item);
            LocalEventDispatcher.dispatch(operation);
        }
        else if (!(this.props.selectionCallBack == null)) {
            this.props.selectionCallBack(person, item);
        }

        this.clearQuestyString();

        if (!(this.props.changedTextValueEvent == null)) {
            var operation = new LocalEvent(this.props.changedTextValueEvent);
            operation.AddItem("value", item.LastName + ", " + item.FirstName + " (" + item.LicenceNumber + ")");
            LocalEventDispatcher.dispatch(operation);
        }
        else if (!(this.props.changedTextValueCallback == null)) {
            this.props.changedTextValueCallback(item.LastName + ", " + item.FirstName + " (" + item.LicenceNumber + ")");
        }

        if (this.props.closeDropDownAfterSelection) { this.clearState(); }
    }

    private removeItem(item: Person, e: React.MouseEvent): void {
        e.stopPropagation();
        var p = new PersonDropdownItem();
        p.Item = item;
        p.Active = false;

        if (!(this.props.clearOp == null)) {
            var operation = new LocalEvent(this.props.clearOp);
            operation.AddItem("value", p);
            LocalEventDispatcher.dispatch(operation);
        }
        else if (!(this.props.clearCallBack == null)) {
            this.props.clearCallBack(p);
        }

        this.clearQuestyString();
    }

    private searchTextChanged(e: React.ChangeEvent<HTMLInputElement>): void {
        if (this.timeoutReference != null) {
            clearTimeout(this.timeoutReference);
            this.timeoutReference = null;
        }

        var q = e.target.value;
        var state = new ReferalDoctorSearchAutocompleteCustomState(this.state);
        state.textValue = q;
        this.setState(state);

        if (!(this.props.changedTextValueEvent == null)) {
            var operation = new LocalEvent(this.props.changedTextValueEvent);
            operation.AddItem("value", q);
            LocalEventDispatcher.dispatch(operation);
        }
        else if (!(this.props.changedTextValueCallback == null)) {
            this.props.changedTextValueCallback(q);
        }

        var self = this;
        this.timeoutReference = window.setTimeout(() => {
            self.invokeDebouncedSearch(q);
        }, self.debounceMs);
    }

    private invokeDebouncedSearch(q: string): void {
        if (q == null) return;
        var self = this;
        if (q.length < this.minQueryLengthSearchChars) return;
        var data = {
            SearchString: q,
            MaxResults: self.returnMaxResults,
            LicenceOrganisationRuleId: this.props.LicenceOrganisationRuleId,
            StateLookUpId: sessionStore.getCurrentEmployeeActiveSiteStateLookUpId()
        };
        var client = new Client();
        client.Post(apiSettings.buildApiPath(), ServerOperations.Server.MedfarDictionnary_SearchDoctors, data, this.onResponseReceived.bind(this), error => console.error(error));
    }

    private onResponseReceived(response: SearchLicenceResult): void {
        var collection = response.SearchLicenceResults;
        collection.forEach(i => {
            i.OrganisationCode = cacheStore.AllLicenseOrganizationRulesById[i.LicenceOrganisationRuleId]?.OrganisationCode;
            i.IsHighlighted = false;
        });

        var state = new ReferalDoctorSearchAutocompleteCustomState(this.state);
        state.expanded = true;
        state.doctors = collection;
        this.setState(state);
    }

    private collapseDropdown(): void {
        this.changeDropdown(false);
    }

    private changeDropdown(expand: boolean): void {
        var state = new ReferalDoctorSearchAutocompleteCustomState(); state.expanded = expand; state.infocus = this.state.infocus; state.doctors = this.state.doctors; state.textValue = this.state.textValue; this.setState(state);
    }

    private clearState(): void {
        var state = new ReferalDoctorSearchAutocompleteCustomState();
        state.expanded = false;
        state.infocus = false;
        state.doctors = [];
        state.textValue = "";
        this.setState(state);
    }

    private clearQuestyString(): void {
        var state = new ReferalDoctorSearchAutocompleteCustomState(this.state);
        state.textValue = "";
        this.setState(state);
    }
}

export { ReferalDoctorSearchAutocompleteCustom };
